// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_N_N","cls2":"ReportList-cls2_0tf ReportList-cls1_N_N"};